"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceEntity = void 0;
class InvoiceEntity {
    id;
    owner;
    documentType;
    correctsInvoice;
    correctsInvoiceNumber;
    rectificationReason;
    rectificationScope;
    authoringOrigin;
    draftId;
    replacesInvoice;
    replacedByInvoice;
    issuedBy;
    deliveryStatus;
    operationDate;
    fiscalRegime;
    issuerAuthorizationId;
    invoiceSeries;
    invoiceSeriesYear;
    invoiceSequence;
    numberingVersion;
    deliveryEmail;
    deliveryName;
    deliveryLang;
    emailDeliveries;
    invoice_number;
    date_of_issue;
    date_due;
    bill_from;
    bill_to;
    title;
    vat_applied;
    items;
    breakdown;
    transaction;
    transactions;
    archived;
    createdAt;
    updatedAt;
}
exports.InvoiceEntity = InvoiceEntity;
